<template>
  <div class="medical-dashboard">
    <!-- 顶部导航栏 -->
    <div class="dashboard-navbar">
      <div class="navbar-content">
        <div class="brand-section">
          <div class="ai-indicator">
            <i class="fas fa-city"></i>
            <span class="ai-pulse"></span>
          </div>
          <i class="fas fa-hospital-alt"></i>
          <div class="brand-text">
            <h1>智慧医疗租赁监控平台</h1>
            <span></span>
          </div>
        </div>
        <div class="navbar-actions">
          <div class="ai-assistant">
            <div class="ai-status">
              <i class="fas fa-robot"></i>
              <span>系统运行正常</span>
            </div>
          </div>
          <router-link class="nav-link order-analysis-link" to="/ai-order">
            <i class="fas fa-chart-pie"></i>
            订单分析
          </router-link>
          <a
            class="nav-link order-analysis-link"
            href="http://39.100.83.107:3000"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="fas fa-book"></i>
            AI日志分析
          </a>
          <div class="time-display">
            <div class="current-time">{{ currentTime }}</div>
            <div class="current-date">{{ currentDate }}</div>
          </div>
          <div class="status-indicator">
            <span class="status-dot online"></span>
            <span class="status-text">智能监控运行中</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 核心指标区域 -->
    <div class="kpi-section">
      <div class="kpi-grid">
        <div class="kpi-card total-devices">
          <div class="kpi-icon">
            <i class="fas fa-boxes"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-value">{{ formatNumber(metricsDisplay.totalDevices) }}</div>
            <div class="kpi-label">总设备数</div>
            <div class="kpi-trend positive">
              <i class="fas fa-arrow-up"></i>
              +2.1%
            </div>
            <div class="ai-prediction">
              <i class="fas fa-chart-line"></i>
              预测: +8.5% (下月)
            </div>
          </div>
        </div>

        <div class="kpi-card active-devices">
          <div class="kpi-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-value">{{ formatNumber(metricsDisplay.activeDevices) }}</div>
            <div class="kpi-label">在线设备</div>
            <div class="kpi-trend positive">
              <i class="fas fa-arrow-up"></i>
              +5.3%
            </div>
            <div class="ai-prediction">
              <i class="fas fa-chart-line"></i>
              系统优化: +12.3%
            </div>
          </div>
        </div>

        <div class="kpi-card utilization-rate">
          <div class="kpi-icon">
            <i class="fas fa-chart-line"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-value">{{ formatNumber(metricsDisplay.utilizationRate, 1) }}%</div>
            <div class="kpi-label">设备利用率</div>
            <div class="kpi-trend positive">
              <i class="fas fa-arrow-up"></i>
              +3.2%
            </div>
            <div class="ai-prediction">
              <i class="fas fa-robot"></i>
              智能调度: +15.7%
            </div>
          </div>
        </div>

        <div class="kpi-card maintenance-count">
          <div class="kpi-icon">
            <i class="fas fa-tools"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-value">{{ formatNumber(metricsDisplay.maintenanceCount) }}</div>
            <div class="kpi-label">维修中设备</div>
            <div class="kpi-trend negative">
              <i class="fas fa-arrow-down"></i>
              -1.8%
            </div>
            <div class="ai-prediction">
              <i class="fas fa-wrench"></i>
              预测维修: 3台
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 智能洞察区域 -->
    <div class="ai-insights-section">
      <div class="ai-insights-grid">
        <div class="ai-card predictive-analytics">
          <div class="ai-card-header">
            <div class="ai-icon">
              <i class="fas fa-chart-line"></i>
            </div>
            <h3>预测分析</h3>
          </div>
          <div class="ai-card-content">
            <div class="prediction-item">
              <div class="prediction-icon success">
                <i class="fas fa-check-circle"></i>
              </div>
              <div class="prediction-text">
                <span class="prediction-title">设备维修预测</span>
                <span class="prediction-value">预计未来7天内需安排 2 台充电宝、1 台轮椅、1 台陪护床检修</span>
              </div>
            </div>
            <div class="prediction-item">
              <div class="prediction-icon warning">
                <i class="fas fa-exclamation-triangle"></i>
              </div>
              <div class="prediction-text">
                <span class="prediction-title">电量预警</span>
                <span class="prediction-value">预测未来8小时内有 5 台陪护床、3 台轮椅电量将低于20%</span>
              </div>
            </div>
          </div>
        </div>

        <div class="ai-card smart-optimization">
          <div class="ai-card-header">
            <div class="ai-icon">
              <i class="fas fa-cogs"></i>
            </div>
            <h3>智能优化建议</h3>
          </div>
          <div class="ai-card-content">
            <div class="optimization-item">
              <div class="optimization-badge">高优先级</div>
              <div class="optimization-text">
                <span class="optimization-title">设备调度优化</span>
                <span class="optimization-desc">可提升利用率15.7%</span>
              </div>
            </div>
            <div class="optimization-item">
              <div class="optimization-badge">中优先级</div>
              <div class="optimization-text">
                <span class="optimization-title">库存管理</span>
                <span class="optimization-desc">建议调整备件库存</span>
              </div>
            </div>
          </div>
        </div>

        <div class="ai-card automation-workflow">
          <div class="ai-card-header">
            <div class="ai-icon">
              <i class="fas fa-play-circle"></i>
            </div>
            <h3>自动化工作流</h3>
          </div>
          <div class="ai-card-content">
            <div class="workflow-item active">
              <div class="workflow-status">
                <i class="fas fa-spinner fa-spin"></i>
              </div>
              <div class="workflow-text">
                <span class="workflow-title">智能维护调度</span>
                <span class="workflow-status-text">执行中</span>
              </div>
            </div>
            <div class="workflow-item completed">
              <div class="workflow-status">
                <i class="fas fa-check"></i>
              </div>
              <div class="workflow-text">
                <span class="workflow-title">设备状态监控</span>
                <span class="workflow-status-text">已完成</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 设备状态概览 -->
    <div class="device-overview-section">
      <div class="section-header">
        <h2>设备状态概览</h2>
        <div class="device-selector">
          <button
            v-for="device in deviceTypes"
            :key="device.key"
            :class="['device-type-btn', { active: selectedDeviceType === device.key }]"
            @click="selectDeviceType(device.key)"
          >
            <i :class="device.icon"></i>
            {{ device.name }}
          </button>
        </div>
      </div>

      <div class="device-status-grid">
        <div class="status-card available">
          <div class="status-icon">
            <i class="fas fa-circle"></i>
          </div>
          <div class="status-info">
            <div class="status-value">
              {{ getDeviceStatus('available') }}
              <span class="status-heartbeat">/ {{ getTotalHeartbeat() }}</span>
            </div>
            <div class="status-label">可用设备 / 总链接数</div>
          </div>
        </div>

        <div class="status-card in-use">
          <div class="status-icon">
            <i class="fas fa-circle"></i>
          </div>
          <div class="status-info">
            <div class="status-value">{{ getDeviceStatus('inUse') }}</div>
            <div class="status-label">使用中</div>
          </div>
        </div>

        <div class="status-card maintenance">
          <div class="status-icon">
            <i class="fas fa-circle"></i>
          </div>
          <div class="status-info">
            <div class="status-value">{{ getDeviceStatus('maintenance') }}</div>
            <div class="status-label">维修中</div>
          </div>
        </div>

        <div class="status-card offline">
          <div class="status-icon">
            <i class="fas fa-circle"></i>
          </div>
          <div class="status-info">
            <div class="status-value">{{ getDeviceStatus('offline') }}</div>
            <div class="status-label">离线设备</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 数据可视化区域 -->
    <div class="charts-section">
      <div class="charts-grid">
        <!-- 中国医院分布图 -->
        <div class="chart-card map-chart">
          <div class="chart-header">
            <h3>全国医院设备分布</h3>
            <div class="chart-actions">
              <button class="chart-btn">
                <i class="fas fa-expand"></i>
              </button>
            </div>
          </div>
          <div class="chart-body">
            <echart :options="chinaMapChart" autoresize />
          </div>
        </div>

        <!-- 设备使用趋势 -->
        <div class="chart-card trend-chart">
          <div class="chart-header">
            <h3>设备使用趋势</h3>
            <div class="chart-filters">
              <select v-model="timeRange" @change="updateChartData">
                <option value="hour">最近1小时</option>
                <option value="day">最近24小时</option>
                <option value="week">最近7天</option>
                <option value="month">最近30天</option>
              </select>
            </div>
          </div>
          <div class="chart-body">
            <echart :options="usageTrendChart" autoresize />
          </div>
        </div>

        <!-- 设备类型分布 -->
        <div class="chart-card type-chart">
          <div class="chart-header">
            <h3>设备类型分布</h3>
          </div>
          <div class="chart-body">
            <echart :options="deviceTypeChart" autoresize />
          </div>
        </div>

        <!-- 医院设备统计 -->
        <div class="chart-card hospital-chart">
          <div class="chart-header">
            <h3>医院设备统计</h3>
          </div>
          <div class="chart-body">
            <echart :options="hospitalStatsChart" autoresize />
          </div>
        </div>

        <!-- 维修人员出勤热力图 -->
        <div class="chart-card" style="grid-column: 1/3;">
          <div class="chart-header">
            <h3>维修人员出勤（最近30天）</h3>
          </div>
          <div class="chart-body">
            <echart :options="maintenanceStaffChart" autoresize />
          </div>
        </div>

        <!-- 最新订单 -->
        <div class="chart-card latest-orders-card" style="grid-column: 3/5;">
          <div class="chart-header">
            <h3>最新订单（未包含充电宝）</h3>
          </div>
          <div class="chart-body orders-table-body">
            <div class="orders-table-wrapper">
              <table class="orders-table">
                <thead>
                  <tr>
                    <th>订单号</th>
                    <th>设备号</th>
                    <th>租借时间</th>
                    <th>租借地点</th>
                    <th>消费金额</th>
                    <th>归还时间</th>
                    <th>归还状态</th>
                    <th>支付状态</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order in latestOrders" :key="order.id || order.orderNumber">
                    <td>{{ order.orderNumber || '-' }}</td>
                    <td>{{ order.equipmentNumber || '-' }}</td>
                    <td>{{ formatOrderTime(order.borrowTime || order.startTime) }}</td>
                    <td>{{ order.merchantName || '-' }}</td>
                    <td class="order-amount">¥{{ formatAmount(order.spend || order.amount || order.totalAmount || 0) }}</td>
                    <td>{{ formatOrderTime(order.returnTime || order.endTime) }}</td>
                    <td>
                      <span :class="['order-status', getOrderStatusClass(order.state)]">
                        {{ getOrderStatusText(order.state) }}
                      </span>
                    </td>
                    <td>
                      <span :class="['order-status', getPaymentStatusClass(order.orderType, order.payStatus)]">
                        {{ getPaymentStatusText(order.orderType, order.payStatus) }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="latestOrders.length === 0">
                    <td colspan="8" class="no-data">暂无订单数据</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="orders-pagination" v-if="orderPager.total > 0">
              <button
                class="pagination-btn"
                :disabled="orderPager.currentPage === 1"
                @click="changeOrderPage(orderPager.currentPage - 1)"
              >
                <i class="fas fa-chevron-left"></i>
              </button>
              <span class="pagination-info">
                第 {{ orderPager.currentPage }} / {{ orderPager.pages }} 页
              </span>
              <button
                class="pagination-btn"
                :disabled="orderPager.currentPage >= orderPager.pages"
                @click="changeOrderPage(orderPager.currentPage + 1)"
              >
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 监控与决策支持 -->
    <div class="smart-monitoring-section">
      <div class="monitoring-header">
        <h2>设备监控中心</h2>
        <div class="monitoring-status">
          <span class="ai-indicator">
            <i class="fas fa-shield-alt"></i>
            系统监控中
          </span>
          <span class="live-indicator">
            <i class="fas fa-circle"></i>
            实时分析
          </span>
        </div>
      </div>

      <div class="smart-monitoring-content">
        <div class="ai-decision-panel">
          <div class="panel-header">
            <h4>决策建议</h4>
            <div class="ai-confidence">
              <span class="confidence-score">置信度: 94%</span>
            </div>
          </div>
          <div class="decision-list">
            <div class="decision-item high-priority">
              <div class="decision-icon">
                <i class="fas fa-lightbulb"></i>
              </div>
              <div class="decision-content">
                <div class="decision-title">设备调度优化</div>
                <div class="decision-desc">建议中石油中心医院将5号楼4层、3层增加10张陪护床，可提升营收25%</div>

              </div>
            </div>
            <div class="decision-item medium-priority">
              <div class="decision-icon">
                <i class="fas fa-tools"></i>
              </div>
              <div class="decision-content">
                <div class="decision-title">预防性维护</div>
                <div class="decision-desc">检测到5台设备（陪护床、轮椅）需要提前维护</div>
                <div class="decision-actions">
                  <button class="decision-btn schedule">安排维护</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ai-alerts-panel">
          <div class="panel-header">
            <h4>智能告警分析</h4>
            <span class="alert-count">{{ alerts.length }}</span>
          </div>
          <div class="smart-alerts-list">
            <div
              v-for="alert in alerts"
              :key="alert.id"
              :class="['alert-item', alert.level]"
            >
              <div class="alert-icon">
                <i :class="alert.icon"></i>
              </div>
              <div class="alert-content">
                <div class="alert-title">{{ alert.title }}</div>
                <div class="alert-message">{{ alert.message }}</div>
                <div class="alert-meta">
                  <span class="alert-time">{{ alert.time }}</span>
                  <span class="ai-analysis">分析: {{ alert.aiAnalysis }}</span>
                </div>
              </div>
              <div class="alert-actions">
                <button class="alert-btn" @click="handleAlert(alert)">
                  处理
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="ai-activities-panel">
          <div class="panel-header">
            <h4>智能活动监控</h4>
            <div class="activity-filter">
              <select v-model="activityFilter">
                <option value="all">全部活动</option>
                <option value="ai">自动化操作</option>
                <option value="system">系统事件</option>
                <option value="user">用户操作</option>
              </select>
            </div>
          </div>
          <div class="smart-activities-list">
            <div
              v-for="activity in recentActivities"
              :key="activity.id"
              :class="['activity-item', activity.type]"
            >
              <div class="activity-icon">
                <i :class="activity.icon"></i>
              </div>
              <div class="activity-content">
                <div class="activity-title">{{ activity.title }}</div>
                <div class="activity-desc">{{ activity.description }}</div>
                <div class="activity-meta">
                  <span class="activity-time">{{ activity.time }}</span>
                  <span v-if="activity.aiGenerated" class="ai-generated">
                    <i class="fas fa-robot"></i>
                    系统生成
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部版权与返回平台 -->
    <div class="dashboard-footer">
      <div class="footer-left">
        © {{ new Date().getFullYear() }} 智慧医疗租赁监控平台
      </div>
      <div class="footer-right">
        <router-link class="footer-link" to="/order">
          返回平台（订单管理）
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/map'
import 'echarts/lib/chart/heatmap'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/visualMap'
import 'echarts/map/js/china.js'
import { fetchGet } from '@/api/axios_config.js'
import { api } from '@/api/api.js'
import { mapState } from 'vuex'

export default {
  name: 'Home',
  components: {
    echart: ECharts
  },
  computed: {
    ...mapState('userModule', ['userId'])
  },
  data() {
    return {
      currentTime: '',
      currentDate: '',
      selectedDeviceType: 'all',
      timeRange: 'day',

      // 设备类型配置
      deviceTypes: [
        { key: 'all', name: '全部设备', icon: 'fas fa-boxes' },
        { key: 'powerbank', name: '充电宝', icon: 'fas fa-battery-full' },
        { key: 'wheelchair', name: '轮椅', icon: 'fas fa-wheelchair' },
        { key: 'bed', name: '陪护床', icon: 'fas fa-bed' }
      ],

      // 核心指标数据（真实值）
      metrics: {
        totalDevices: 2847,
        activeDevices: 2456,
        utilizationRate: 86.2,
        maintenanceCount: 23
      },

      // 核心指标数据（用于带动画展示）
      metricsDisplay: {
        totalDevices: 0,
        activeDevices: 0,
        utilizationRate: 0,
        maintenanceCount: 0
      },

      // 设备状态数据
      deviceStatus: {
        all: {
          available: 2456,
          inUse: 312,
          maintenance: 23,
          offline: 56
        },
        powerbank: {
          available: 892,
          inUse: 98,
          maintenance: 8,
          offline: 12
        },
        wheelchair: {
          available: 756,
          inUse: 145,
          maintenance: 12,
          offline: 22
        },
        bed: {
          available: 808,
          inUse: 69,
          maintenance: 3,
          offline: 22
        }
      },

      // 告警数据
      alerts: [
        {
          id: 1,
          level: 'warning',
          icon: 'fas fa-exclamation-triangle',
          title: '设备电量不足',
          message: '陪护床 PB001 电量低于20%',
          time: '2分钟前',
          aiAnalysis: '预测24小时内耗尽，建议立即更换'
        },
        {
          id: 2,
          level: 'info',
          icon: 'fas fa-info-circle',
          title: '新订单创建',
          message: '轮椅租赁订单 - 阜外医院',
          time: '5分钟前',
          aiAnalysis: '匹配度95%，自动分配设备WH003'
        },
        {
          id: 3,
          level: 'success',
          icon: 'fas fa-check-circle',
          title: '维修完成',
          message: '陪护床 BED005 维修完成并上线',
          time: '10分钟前',
          aiAnalysis: '质量检测通过，性能提升12%'
        }
      ],

      // 活动数据
      recentActivities: [
        {
          id: 1,
          icon: 'fas fa-robot',
          title: '自动调度',
          description: '智能分配3台轮椅至急诊科',
          time: '1分钟前',
          type: 'ai',
          aiGenerated: true
        },
        {
          id: 2,
          icon: 'fas fa-tools',
          title: '预防性维护',
          description: '系统自动安排设备保养计划',
          time: '3分钟前',
          type: 'system',
          aiGenerated: true
        },
        {
          id: 3,
          icon: 'fas fa-user',
          title: '订单处理',
          description: '用户创建了投诉订单，请立即处理。',
          time: '5分钟前',
          type: 'user',
          aiGenerated: false
        },
        {
          id: 4,
          icon: 'fas fa-chart-bar',
          title: '智能预测',
          description: '预测明天需额外准备5台设备',
          time: '8分钟前',
          type: 'ai',
          aiGenerated: true
        }
      ],

      // 活动过滤器
      activityFilter: 'all',

      // 决策采纳状态
      decisionAccepted: false,

      // 最新订单数据
      latestOrders: [],
      orderPager: {
        currentPage: 1,
        pages: 1,
        total: 0,
        size: 10
      },

      // 中国地图配置
      chinaMapChart: {
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>设备数量: {c}'
        },
        visualMap: {
          min: 0,
          max: 1000,
          left: 'left',
          bottom: 10,
          text: ['高', '低'],
          calculable: true,
          inRange: {
            color: ['#e0f7fa', '#b2ebf2', '#80deea', '#4dd0e1', '#00bcd4']
          }
        },
        series: [
          {
            name: '医院设备分布',
            type: 'map',
            mapType: 'china',
            layoutCenter: ['50%', '55%'],
            layoutSize: '90%',
            roam: true,
            label: {
              show: true,
              fontSize: 10,
              color: '#333'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                fontWeight: 'bold',
                color: '#000'
              },
              itemStyle: {
                areaColor: '#00bcd4',
                borderWidth: 2,
                borderColor: '#0097a7'
              }
            },
            data: [
              { name: '北京', value: 850 },
              { name: '河北', value: 720 },
              { name: '山东', value: 680 },
              { name: '河南', value: 650 },
              { name: '天津', value: 420 },
              { name: '山西', value: 380 },
              { name: '江苏', value: 350 },
              { name: '浙江', value: 320 },
              { name: '上海', value: 300 },
              { name: '广东', value: 280 },
              { name: '湖北', value: 250 },
              { name: '湖南', value: 220 },
              { name: '四川', value: 200 },
              { name: '辽宁', value: 180 },
              { name: '吉林', value: 160 },
              { name: '黑龙江', value: 140 },
              { name: '安徽', value: 130 },
              { name: '江西', value: 120 },
              { name: '福建', value: 110 },
              { name: '广西', value: 100 },
              { name: '海南', value: 80 },
              { name: '贵州', value: 70 },
              { name: '云南', value: 60 },
              { name: '西藏', value: 40 },
              { name: '陕西', value: 150 },
              { name: '甘肃', value: 90 },
              { name: '青海', value: 50 },
              { name: '宁夏', value: 45 },
              { name: '新疆', value: 55 },
              { name: '内蒙古', value: 85 },
              { name: '重庆', value: 95 }
            ]
          }
        ]
      },

      // 设备使用趋势图
      usageTrendChart: {
        textStyle: {
          color: '#e0e0e0'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['充电宝', '轮椅', '陪护床'],
          top: 0,
          textStyle: {
            color: '#e0e0e0'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00', '24:00'],
          axisLabel: {
            color: '#e0e0e0'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#e0e0e0'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        series: [
          {
            name: '充电宝',
            type: 'line',
            stack: 'Total',
            smooth: true,
            symbol: 'none',
            lineStyle: {
              width: 3
            },
            areaStyle: {
              opacity: 0.3
            },
            data: [120, 132, 101, 134, 90, 230, 210],
            color: '#00bcd4'
          },
          {
            name: '轮椅',
            type: 'line',
            stack: 'Total',
            smooth: true,
            symbol: 'none',
            lineStyle: {
              width: 3
            },
            areaStyle: {
              opacity: 0.3
            },
            data: [220, 182, 191, 234, 290, 330, 310],
            color: '#4caf50'
          },
          {
            name: '陪护床',
            type: 'line',
            stack: 'Total',
            smooth: true,
            symbol: 'none',
            lineStyle: {
              width: 3
            },
            areaStyle: {
              opacity: 0.3
            },
            data: [150, 232, 201, 154, 190, 330, 410],
            color: '#ff9800'
          }
        ]
      },

      // 设备类型分布饼图
      deviceTypeChart: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'horizontal',
          bottom: 15,
          left: 'center',
          textStyle: {
            color: '#e0e0e0'
          }
        },
        series: [
          {
            name: '设备类型',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '45%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 8,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold',
                color: '#ffffff'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: 1012,
                name: '充电宝',
                itemStyle: { color: '#00bcd4' }
              },
              {
                value: 935,
                name: '轮椅',
                itemStyle: { color: '#4caf50' }
              },
              {
                value: 900,
                name: '陪护床',
                itemStyle: { color: '#ff9800' }
              }
            ]
          }
        ]
      },

      // 医院设备统计柱状图
      hospitalStatsChart: {
        textStyle: {
          color: '#e0e0e0'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['总设备数', '在线设备', '使用中'],
          top: 0,
          textStyle: {
            color: '#e0e0e0'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['阜外医院', '邢台三院', '眼科医院', '中央音乐学院', '中美医院', '河北中石油医院', '沈阳体育学院'],
          axisLabel: {
            rotate: 45,
            color: '#e0e0e0'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#e0e0e0'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        series: [
          {
            name: '总设备数',
            type: 'bar',
            data: [320, 280, 250, 180, 220, 200, 150],
            itemStyle: {
              color: '#e3f2fd'
            },
            barWidth: '20%'
          },
          {
            name: '在线设备',
            type: 'bar',
            data: [310, 270, 240, 175, 215, 195, 145],
            itemStyle: {
              color: '#00bcd4'
            },
            barWidth: '20%'
          },
          {
            name: '使用中',
            type: 'bar',
            data: [125, 110, 95, 65, 85, 78, 58],
            itemStyle: {
              color: '#4caf50'
            },
            barWidth: '20%'
          }
        ]
      },

      // 维修人员出勤热力图（最近30天）
      maintenanceStaffChart: {
        textStyle: {
          color: '#e0e0e0'
        },
        tooltip: {
          trigger: 'item',
          formatter(params) {
            const dateLabels = ['01日', '05日', '10日', '15日', '20日', '25日', '30日']
            const cityLabels = ['阜外医院', '邢台三院', '眼科医院', '中央音乐学院', '中美医院', '河北中石油医院']
            const xIndex = params.value[0]
            const yIndex = params.value[1]
            const date = dateLabels[xIndex] || ''
            const city = cityLabels[yIndex] || ''
            const hasTask = params.value[2] > 0 ? '是' : '否'
            return `${city}<br/>日期：${date}<br/>当日有维修任务：${hasTask}`
          }
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: 40,
          top: 60,
          containLabel: true
        },
        visualMap: {
          min: 0,
          max: 1,
          calculable: false,
          orient: 'horizontal',
          left: 'center',
          top: 10,
          inRange: {
            color: ['#1e3a5f', '#00bcd4']
          },
          textStyle: {
            color: '#e0e0e0'
          },
          show: true,
          formatter(value) {
            return value > 0 ? '有任务' : '无任务'
          }
        },
        xAxis: {
          type: 'category',
          data: ['01日', '05日', '10日', '15日', '20日', '25日', '30日'],
          axisLabel: {
            color: '#e0e0e0'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          }
        },
        yAxis: {
          type: 'category',
          data: ['阜外医院', '邢台三院', '眼科医院', '中央音乐学院', '中美医院', '河北中石油医院'],
          axisLabel: {
            color: '#e0e0e0'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        series: [
          {
            name: '出勤',
            type: 'heatmap',
            data: [
              // [xIndex, yIndex, 是否出勤(0/1)]
              [0, 0, 1], [1, 0, 0], [2, 0, 1], [3, 0, 0], [4, 0, 1], [5, 0, 0], [6, 0, 1], // 阜外医院
              [0, 1, 0], [1, 1, 1], [2, 1, 0], [3, 1, 1], [4, 1, 0], [5, 1, 1], [6, 1, 0], // 邢台三院
              [0, 2, 0], [1, 2, 0], [2, 2, 1], [3, 2, 0], [4, 2, 0], [5, 2, 1], [6, 2, 0], // 眼科医院
              [0, 3, 0], [1, 3, 0], [2, 3, 0], [3, 3, 1], [4, 3, 0], [5, 3, 0], [6, 3, 1], // 中央音乐学院
              [0, 4, 0], [1, 4, 0], [2, 4, 0], [3, 4, 0], [4, 4, 1], [5, 4, 0], [6, 4, 0], // 中美医院
              [0, 5, 0], [1, 5, 0], [2, 5, 0], [3, 5, 0], [4, 5, 0], [5, 5, 1], [6, 5, 0]  // 河北中石油医院
            ],
            label: {
              show: false
            }
          }
        ]
      }
    }
  },

  mounted() {
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)

    // KPI 数字入场动画
    this.animateMetric('totalDevices', this.metrics.totalDevices)
    this.animateMetric('activeDevices', this.metrics.activeDevices)
    this.animateMetric('utilizationRate', this.metrics.utilizationRate, 1)
    this.animateMetric('maintenanceCount', this.metrics.maintenanceCount)

    // 加载最新订单
    this.loadLatestOrders()
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },

  methods: {
    updateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleTimeString('zh-CN', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      this.currentDate = now.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      })
    },

    selectDeviceType(type) {
      this.selectedDeviceType = type
    },

    getDeviceStatus(status) {
      const data = this.deviceStatus[this.selectedDeviceType] || this.deviceStatus.all
      return data[status] || 0
    },

    // 获取总心跳或连接服务端数量（可用设备数 × 9.8）
    getTotalHeartbeat() {
      const available = this.getDeviceStatus('available')
      return Math.round(available * 9.8)
    },

    updateChartData() {
      // 根据时间范围更新图表数据
      console.log('更新图表数据:', this.timeRange)
    },

    handleAlert(alert) {
      // 处理告警
      console.log('处理告警:', alert)
      // 这里可以添加处理逻辑，如标记为已读、跳转到详情页等
    },

    // 数字动画：从当前显示值缓动到目标值
    animateMetric(field, targetValue, fractionDigits = 0, duration = 800) {
      const startTime = performance.now()
      const startValue = Number(this.metricsDisplay[field]) || 0
      const endValue = Number(targetValue) || 0

      const step = now => {
        const progress = Math.min((now - startTime) / duration, 1)
        const current = startValue + (endValue - startValue) * progress

        if (fractionDigits > 0) {
          this.metricsDisplay[field] = Number(current.toFixed(fractionDigits))
        } else {
          this.metricsDisplay[field] = Math.round(current)
        }

        if (progress < 1) {
          requestAnimationFrame(step)
        }
      }

      requestAnimationFrame(step)
    },

    // 数字格式化：千分位 + 小数位
    formatNumber(value, fractionDigits = 0) {
      const num = Number(value) || 0
      return num.toLocaleString('zh-CN', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      })
    },

    // 加载最新订单
    async loadLatestOrders() {
      try {
        const res = await fetchGet(api.getTodayOrders, {
          current: this.orderPager.currentPage,
          pageSize: this.orderPager.size,
          openid: this.userId
        })

        if (res.data && res.data.records) {
          this.latestOrders = res.data.records.map(item => {
            // 格式化订单状态
            switch (item.state) {
              case '2':
                item.stateText = '未归还'
                break
              case '3':
                item.stateText = '已归还'
                break
              case '1':
                item.stateText = '新建订单'
                break
              default:
                item.stateText = item.state || '-'
            }
            return item
          })

          this.orderPager = {
            pages: res.data.pages || 1,
            currentPage: res.data.current || 1,
            total: res.data.total || 0,
            size: res.data.size || 10
          }
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('loadLatestOrders error:', e)
        this.latestOrders = []
      }
    },

    // 切换订单页码
    changeOrderPage(page) {
      if (page >= 1 && page <= this.orderPager.pages) {
        this.orderPager.currentPage = page
        this.loadLatestOrders()
      }
    },

    // 格式化订单时间
    formatOrderTime(time) {
      if (!time) return '-'
      const date = new Date(time)
      if (isNaN(date.getTime())) return time
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    // 格式化金额
    formatAmount(amount) {
      const num = Number(amount) || 0
      return num.toFixed(2)
    },

    // 获取订单状态文本
    getOrderStatusText(state) {
      switch (state) {
        case '2':
          return '未归还'
        case '3':
          return '已归还'
        case '1':
          return '新建订单'
        default:
          return state || '-'
      }
    },

    // 获取订单状态样式类
    getOrderStatusClass(state) {
      switch (state) {
        case '3':
          return 'status-returned'
        case '2':
          return 'status-using'
        case '1':
          return 'status-new'
        default:
          return 'status-default'
      }
    },

    // 获取支付状态文本
    getPaymentStatusText(orderType, payStatus) {
      // 先判断支付类型
      let paymentType = ''
      switch (orderType) {
        case 0:
          paymentType = '微信'
          break
        case 1:
          paymentType = '支付宝'
          break
        case 2:
          paymentType = '支付宝预授权'
          break
        case 3:
          paymentType = '微信预授权'
          break
        default:
          paymentType = '未知'
      }

      // 如果有支付状态，则显示支付状态
      if (payStatus !== undefined && payStatus !== null) {
        if (payStatus === 1 || payStatus === '1' || payStatus === true) {
          return `${paymentType} - 已支付`
        } else {
          return `${paymentType} - 未支付`
        }
      }

      // 默认显示支付类型
      return paymentType || '-'
    },

    // 获取支付状态样式类
    getPaymentStatusClass(orderType, payStatus) {
      // 如果已支付，显示成功状态
      if (payStatus === 1 || payStatus === '1' || payStatus === true) {
        return 'status-paid'
      }
      // 如果未支付，显示警告状态
      if (payStatus === 0 || payStatus === '0' || payStatus === false) {
        return 'status-unpaid'
      }
      // 默认状态
      return 'status-default'
    },

    // 采纳决策建议
    acceptDecision() {
      this.decisionAccepted = true
      // 这里可以扩展为调用后台接口，记录已采纳的决策
      // eslint-disable-next-line no-console
      console.log('决策已采纳，并已安排相关人员处理')
    }
  }
}
</script>

<style scoped>
/* 全局样式 */
.medical-dashboard {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f0f23 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  color: #e0e0e0;
  padding: 20px;
}

.dashboard-footer {
  margin-top: 16px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
  color: #9e9e9e;
}

.footer-link {
  color: #00bcd4;
  text-decoration: none;
  font-size: 0.75rem;
}

.footer-link:hover {
  text-decoration: underline;
}

/* 顶部导航栏 */
.dashboard-navbar {
  background: rgba(26, 26, 46, 0.8);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  padding: 20px 30px;
  margin-bottom: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.navbar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

.ai-indicator {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #00bcd4, #0097a7);
  border-radius: 50%;
  margin-right: 12px;
  box-shadow: 0 0 20px rgba(0, 188, 212, 0.3);
}

.ai-indicator i {
  font-size: 1.2rem;
  color: white;
}

.ai-pulse {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px solid #00bcd4;
  border-radius: 50%;
  animation: ai-pulse 2s infinite;
}

@keyframes ai-pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

.brand-section i.fa-hospital-alt {
  font-size: 2.5rem;
  color: #00bcd4;
  background: linear-gradient(135deg, #00bcd4, #0097a7);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-text h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #ffffff;
}

.brand-text span {
  color: #b0b0b0;
  font-size: 0.9rem;
  font-weight: 400;
}

.navbar-actions {
  display: flex;
  align-items: center;
  gap: 30px;
}

.order-analysis-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 18px;
  border: 1px solid rgba(0, 188, 212, 0.5);
  color: #00bcd4;
  font-size: 0.85rem;
  text-decoration: none;
  transition: all 0.3s ease;
}

.order-analysis-link i {
  font-size: 0.9rem;
}

.order-analysis-link:hover {
  background: #00bcd4;
  color: #ffffff;
  box-shadow: 0 0 16px rgba(0, 188, 212, 0.4);
}

.ai-assistant {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ai-status {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: rgba(0, 188, 212, 0.1);
  border: 1px solid rgba(0, 188, 212, 0.3);
  border-radius: 20px;
  font-size: 0.85rem;
  color: #00bcd4;
}

.ai-status i {
  font-size: 0.9rem;
}

.time-display {
  text-align: right;
}

.current-time {
  font-size: 1.8rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 4px;
  font-variant-numeric: tabular-nums;
}

.current-date {
  font-size: 0.85rem;
  color: #b0b0b0;
  font-weight: 500;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #4caf50;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.status-text {
  font-size: 0.9rem;
  color: #4caf50;
  font-weight: 500;
}

/* 核心KPI指标区域 */
.kpi-section {
  margin-bottom: 30px;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.kpi-card {
  background: rgba(26, 26, 46, 0.8);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 188, 212, 0.3);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  isolation: isolate;
}

.kpi-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #00bcd4, #0097a7);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.kpi-card:hover::before {
  opacity: 1;
}

/* 边框流动高亮效果 */
.kpi-card::after {
  content: '';
  position: absolute;
  inset: -3px;
  border-radius: 19px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    transparent 15%,
    rgba(0, 188, 212, 0.6) 35%,
    rgba(0, 188, 212, 1) 45%,
    rgba(0, 255, 255, 1) 50%,
    rgba(0, 188, 212, 1) 55%,
    rgba(0, 188, 212, 0.6) 65%,
    transparent 85%,
    transparent 100%
  );
  background-size: 200% 100%;
  animation: border-flow 3s linear infinite;
  pointer-events: none;
  z-index: 0;
  -webkit-mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  -webkit-mask-composite: destination-out;
  mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  mask-composite: exclude;
  padding: 3px;
  will-change: background-position;
  opacity: 1;
  box-shadow: 0 0 20px rgba(0, 188, 212, 1), 0 0 30px rgba(0, 188, 212, 0.6);
  filter: brightness(1.3);
}

@keyframes border-flow {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.kpi-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
  border-color: rgba(0, 188, 212, 0.3);
}

.kpi-icon {
  font-size: 2.5rem;
  margin-right: 20px;
  opacity: 0.8;
}

.total-devices .kpi-icon { color: #00bcd4; }
.active-devices .kpi-icon { color: #4caf50; }
.utilization-rate .kpi-icon { color: #ff9800; }
.maintenance-count .kpi-icon { color: #f44336; }

.kpi-content {
  flex: 1;
  position: relative;
  z-index: 2;
}

.kpi-icon {
  position: relative;
  z-index: 2;
}

.kpi-value {
  font-size: 2.2rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 4px;
  font-variant-numeric: tabular-nums;
}

.kpi-label {
  font-size: 0.9rem;
  color: #b0b0b0;
  font-weight: 500;
  margin-bottom: 8px;
}

.kpi-trend {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-right: 8px;
}

.kpi-trend.positive {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
}

.kpi-trend.negative {
  background: rgba(244, 67, 54, 0.2);
  color: #f44336;
}

.ai-prediction {
  font-size: 0.75rem;
  color: #00bcd4;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 0;
}

.ai-prediction i {
  font-size: 0.8rem;
}

/* AI智能洞察区域 */
.ai-insights-section {
  margin-bottom: 30px;
}

.ai-insights-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
}

.ai-card {
  background: rgba(26, 26, 46, 0.8);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.ai-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
  border-color: rgba(0, 188, 212, 0.3);
}

.ai-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.ai-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #00bcd4, #0097a7);
  color: white;
  font-size: 1.2rem;
}

.ai-card-header h3 {
  margin: 0;
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
}

.ai-card-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.prediction-item, .optimization-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  border-left: 3px solid #00bcd4;
}

.prediction-icon, .optimization-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.prediction-icon.success {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
}

.prediction-icon.warning {
  background: rgba(255, 152, 0, 0.2);
  color: #ff9800;
}

.optimization-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
}

.optimization-badge.high-priority {
  background: rgba(244, 67, 54, 0.2);
  color: #f44336;
}

.optimization-badge.medium-priority {
  background: rgba(255, 152, 0, 0.2);
  color: #ff9800;
}

.prediction-text, .optimization-text {
  flex: 1;
}

.prediction-title, .optimization-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 4px;
}

.prediction-value, .optimization-desc {
  font-size: 0.8rem;
  color: #e0e0e0;
}

.workflow-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
}

.workflow-item.active {
  border-left: 3px solid #00bcd4;
  background: rgba(0, 188, 212, 0.1);
}

.workflow-status {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
}

.workflow-item.completed .workflow-status {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
}

.workflow-text {
  flex: 1;
}

.workflow-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 2px;
}

.workflow-status-text {
  font-size: 0.75rem;
  color: #b0b0b0;
}

/* 设备状态概览 */
.device-overview-section {
  margin-bottom: 30px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #ffffff;
}

.device-selector {
  display: flex;
  gap: 8px;
  background: rgba(26, 26, 46, 0.6);
  border-radius: 12px;
  padding: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.device-type-btn {
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: #b0b0b0;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.device-type-btn:hover {
  background: rgba(0, 188, 212, 0.2);
  color: #00bcd4;
}

.device-type-btn.active {
  background: #00bcd4;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 188, 212, 0.3);
}

.device-status-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.status-card {
  background: rgba(26, 26, 46, 0.8);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: transform 0.3s ease;
}

.status-card:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 255, 255, 0.2);
}

.status-icon {
  font-size: 1.5rem;
  margin-right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.available .status-icon {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
}

.in-use .status-icon {
  background: rgba(0, 188, 212, 0.2);
  color: #00bcd4;
}

.maintenance .status-icon {
  background: rgba(255, 152, 0, 0.2);
  color: #ff9800;
}

.offline .status-icon {
  background: rgba(244, 67, 54, 0.2);
  color: #f44336;
}

.status-info {
  flex: 1;
}

.status-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 4px;
  font-variant-numeric: tabular-nums;
}

.status-heartbeat {
  font-size: 1.2rem;
  font-weight: 500;
  color: #00bcd4;
  margin-left: 4px;
}

.status-label {
  font-size: 0.85rem;
  color: #b0b0b0;
  font-weight: 500;
}

/* 数据可视化区域 */
.charts-section {
  margin-bottom: 30px;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 28px;
}

.chart-card {
  background: rgba(26, 26, 46, 0.8);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: transform 0.3s ease;
}

.chart-card:hover {
  transform: translateY(-4px);
  border-color: rgba(0, 188, 212, 0.3);
}

.chart-header {
  padding: 20px 24px;
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.9), rgba(22, 33, 62, 0.9));
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chart-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #ffffff;
}

.chart-actions, .chart-filters {
  display: flex;
  gap: 8px;
}

.chart-btn {
  padding: 6px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(26, 26, 46, 0.6);
  color: #b0b0b0;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.chart-btn:hover {
  background: #00bcd4;
  color: white;
  border-color: #00bcd4;
}

.chart-filters select {
  padding: 6px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(26, 26, 46, 0.6);
  color: #e0e0e0;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
}

.chart-filters select:focus {
  outline: none;
  border-color: #00bcd4;
}

.chart-body {
  padding: 24px;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 最新订单表格样式 */
.latest-orders-card .chart-body {
  padding: 0;
  height: 400px;
  display: flex;
  flex-direction: column;
}

.orders-table-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}

.orders-table-wrapper {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 16px;
}

.orders-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.75rem;
}

.orders-table thead {
  position: sticky;
  top: 0;
  background: rgba(26, 26, 46, 0.95);
  z-index: 10;
}

.orders-table th {
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  color: #ffffff;
  border-bottom: 2px solid rgba(0, 188, 212, 0.3);
  font-size: 0.8rem;
}

.orders-table td {
  padding: 10px 8px;
  color: #e0e0e0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}

.orders-table tbody tr:hover {
  background: rgba(0, 188, 212, 0.1);
}

.orders-table tbody tr:last-child td {
  border-bottom: none;
}

.order-amount {
  color: #4caf50;
  font-weight: 600;
}

.order-status {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
}

.order-status.status-returned {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
}

.order-status.status-using {
  background: rgba(0, 188, 212, 0.2);
  color: #00bcd4;
}

.order-status.status-new {
  background: rgba(255, 152, 0, 0.2);
  color: #ff9800;
}

.order-status.status-default {
  background: rgba(158, 158, 158, 0.2);
  color: #9e9e9e;
}

.order-status.status-paid {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
}

.order-status.status-unpaid {
  background: rgba(255, 152, 0, 0.2);
  color: #ff9800;
}

.no-data {
  text-align: center;
  color: #9e9e9e;
  padding: 40px 20px !important;
}

.orders-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.pagination-btn {
  padding: 6px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(26, 26, 46, 0.6);
  color: #e0e0e0;
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
}

.pagination-btn:hover:not(:disabled) {
  background: #00bcd4;
  color: #ffffff;
  border-color: #00bcd4;
}

.pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.pagination-info {
  color: #b0b0b0;
  font-size: 0.85rem;
}

/* 智能监控与决策支持 */
.smart-monitoring-section {
  margin-bottom: 30px;
}

.monitoring-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.monitoring-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #ffffff;
}

.monitoring-status {
  display: flex;
  align-items: center;
  gap: 16px;
}

.monitoring-status .ai-indicator,
.monitoring-status .live-indicator {
  position: static;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: rgba(0, 188, 212, 0.1);
  border: 1px solid rgba(0, 188, 212, 0.3);
  border-radius: 20px;
  font-size: 0.85rem;
  color: #00bcd4;
  width: auto;
  height: auto;
  margin-right: 0;
  box-shadow: none;
}

.monitoring-status .ai-indicator i,
.monitoring-status .live-indicator i {
  font-size: 0.9rem;
}

.smart-monitoring-content {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
}

.ai-decision-panel, .ai-alerts-panel, .ai-activities-panel {
  background: rgba(26, 26, 46, 0.8);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.ai-decision-panel:hover, .ai-alerts-panel:hover, .ai-activities-panel:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
  border-color: rgba(0, 188, 212, 0.3);
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.panel-header h4 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #ffffff;
}

.alert-count {
  background: rgba(244, 67, 54, 0.2);
  color: #f44336;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.ai-confidence {
  font-size: 0.8rem;
  color: #00bcd4;
}

.confidence-score {
  font-weight: 600;
}

.decision-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.decision-item {
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  border-left: 3px solid #00bcd4;
}

.decision-content {
  flex: 1;
}

.decision-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 8px;
}

.decision-desc {
  font-size: 0.8rem;
  color: #e0e0e0;
  margin-bottom: 12px;
}

.decision-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.decision-accepted-text {
  font-size: 0.75rem;
  color: #4caf50;
  margin-left: 8px;
}

.decision-btn {
  padding: 6px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(26, 26, 46, 0.8);
  color: #e0e0e0;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.decision-btn.accept {
  border-color: #4caf50;
  color: #4caf50;
}

.decision-btn.accept:hover {
  background: #4caf50;
  color: white;
}

.decision-btn.reject {
  border-color: #f44336;
  color: #f44336;
}

.decision-btn.reject:hover {
  background: #f44336;
  color: white;
}

.decision-btn.schedule {
  border-color: #ff9800;
  color: #ff9800;
}

.decision-btn.schedule:hover {
  background: #ff9800;
  color: white;
}

.smart-alerts-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
}

.alert-item {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background 0.3s ease;
}

.alert-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.alert-item:last-child {
  border-bottom: none;
}

.alert-icon {
  font-size: 1.2rem;
  margin-right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.warning .alert-icon {
  background: rgba(255, 152, 0, 0.1);
  color: #ff9800;
}

.success .alert-icon {
  background: rgba(76, 175, 80, 0.1);
  color: #4caf50;
}

.info .alert-icon {
  background: rgba(0, 188, 212, 0.1);
  color: #00bcd4;
}

.alert-content {
  flex: 1;
}

.alert-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 4px;
}

.alert-message {
  font-size: 0.8rem;
  color: #e0e0e0;
  margin-bottom: 4px;
}

.alert-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.alert-time {
  font-size: 0.75rem;
  color: #adb5bd;
  font-weight: 500;
}

.ai-analysis {
  font-size: 0.7rem;
  color: #00bcd4;
  font-weight: 500;
}

.alert-actions {
  margin-left: 16px;
}

.alert-btn {
  padding: 6px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(26, 26, 46, 0.8);
  color: #e0e0e0;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.alert-btn:hover {
  background: #00bcd4;
  color: white;
  border-color: #00bcd4;
}

.activity-filter {
  display: flex;
  align-items: center;
  gap: 8px;
}

.activity-filter select {
  padding: 6px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(26, 26, 46, 0.6);
  color: #e0e0e0;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
}

.activity-filter select:focus {
  outline: none;
  border-color: #00bcd4;
}

.smart-activities-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
}

.activity-item {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background 0.3s ease;
}

.activity-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.activity-item:last-child {
  border-bottom: none;
}

.activity-icon {
  font-size: 1.2rem;
  margin-right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(108, 117, 125, 0.1);
  color: #6c757d;
}

.activity-content {
  flex: 1;
}

.activity-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 4px;
}

.activity-desc {
  font-size: 0.8rem;
  color: #e0e0e0;
  margin-bottom: 8px;
}

.activity-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.activity-time {
  font-size: 0.75rem;
  color: #adb5bd;
  font-weight: 500;
}

.ai-generated {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  color: #00bcd4;
  font-weight: 500;
}

.ai-generated i {
  font-size: 0.8rem;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .charts-grid {
    grid-template-columns: 1fr;
  }

  .smart-monitoring-content {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .medical-dashboard {
    padding: 15px;
  }

  .navbar-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .kpi-grid {
    grid-template-columns: 1fr;
  }

  .device-status-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .charts-grid {
    grid-template-columns: 1fr;
  }

  .chart-body {
    height: 280px;
  }

  .section-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .device-selector {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .device-status-grid {
    grid-template-columns: 1fr;
  }

  .kpi-card {
    padding: 20px;
  }

  .kpi-value {
    font-size: 1.8rem;
  }

  .status-card {
    padding: 16px;
  }

  .status-value {
    font-size: 1.5rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/page/Home/Index.vue